export const formatMedicalParameterRange = (min, max, suffix = '') =>
  [min, max]
    .filter(value => value !== null && value !== undefined)
    .map(value => {
      const numericValue = Number(value);
      const formattedValue = Number.isFinite(numericValue) && numericValue % 1 === 0
        ? numericValue.toFixed(2)
        : value;

      return `${formattedValue}${suffix}`;
    })
    .join(' - ');

export const formatMedicalParameterAgeRange = (minAge, maxAge) => {
  const hasMinAge = minAge !== null && minAge !== undefined;
  const hasMaxAge = maxAge !== null && maxAge !== undefined;

  if (!hasMinAge && !hasMaxAge) return "Sin rango";
  if (!hasMaxAge) return `Desde ${minAge} años`;
  if (!hasMinAge) return `Hasta ${maxAge} años`;

  return `${minAge} - ${maxAge} años`;
};
